<template>
  <hr-form-dialog
    ref="dialogRef"
    size="sm"
    :title="title"
    @hide="onDialogHide"
    @submit="onSubmit"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ message }}
      </p>
      <div class="col-12">
        <p class="q-mb-xs">
          {{ secondaryMessage }}
        </p>
        <ul class="q-my-none">
          <li
            v-for="field in fieldsList"
            :key="field"
          >
            {{ field }}
          </li>
        </ul>
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        type="submit"
        :label="okButton"
      />
    </template>
  </hr-form-dialog>
</template>

<script setup>
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
} from 'src/design-system';
import { ref } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  fieldsList: {
    type: Array,
    required: true,
  },
  okButton: {
    type: String,
    required: true,
  },
  secondaryMessage: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['ok', 'hide']);

const dialogRef = ref(null);

const show = () => {
  dialogRef.value.show();
};

const hide = () => {
  if (dialogRef.value) {
    dialogRef.value.hide();
  }
};

const onDialogHide = () => {
  emit('hide');
};

const onSubmit = () => {
  emit('ok');
  hide();
};

defineExpose({ show, hide });
</script>
